// Vuex
import { mapState } from 'vuex';

// Constants
// import { COMMUNICATION_ROLE } from '@corefront/constant/messages';
import { MESSAGE_COMMUNICATION_ROLE as COMMUNICATION_ROLE, CHAT_TYPE } from '@/constants/message';

// Components
import ChatBubble from '@corefront/components-v2/Chat/ChatBubble.vue';

// Utils
import { format, fromUnixTime } from 'date-fns';
export default {
  components: {
    ChatBubble
  },
  props: {
    entry: {
      type: Object,
      required: true
    },
    senderName: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState('chat', ['selectedConversation']),
    CHAT_TYPE: () => CHAT_TYPE,
    communicationRole() {
      const {
        entry
      } = this;

      // Events like reassignment_transfer should always be left-aligned
      if (entry.type === 'reassignment_transfer') {
        return COMMUNICATION_ROLE.RECEIVER;
      }
      if (entry.userid == this.selectedConversation.patient.id) {
        return COMMUNICATION_ROLE.RECEIVER;
      } else {
        return COMMUNICATION_ROLE.SENDER;
      }
    },
    avatarText() {
      if (this.communicationRole !== COMMUNICATION_ROLE.RECEIVER) {
        return '';
      }
      if (!this.entry.profileurl) {
        return this.selectedConversation.patient.firstname.charAt(0).toUpperCase() + this.selectedConversation.patient.lastname.charAt(0).toUpperCase();
      } else {
        return '';
      }
    },
    eventName() {
      if (this.entry.type === 'reassignment_transfer') {
        return 'Patient Reassignment';
      }
      return '';
    }
  },
  methods: {
    backgroundClass() {
      if (this.communicationRole === COMMUNICATION_ROLE.RECEIVER) {
        return 'tw-bg-peach';
      } else {
        return 'tw-bg-snow-white';
      }
    },
    formatDate(timestamp) {
      return format(fromUnixTime(timestamp), 'MMM dd, yyyy hh:mm a');
    }
  }
};